import { HttpAdapter } from '../HttpAdapter';
import { basicConfig } from '../../config';
import { Question } from '../../types';

export class QuestionService {
  static getQuestion = (questionID: string) => {
    return HttpAdapter.get(`${basicConfig.gridFitApi}/api/question/${questionID}/light`);
  };

  static findOrGetQuestion = async (testQuestions: Question[], questionID: string | undefined) => {
    if (!questionID) {
      return {};
    }

    const question = testQuestions.find((q: Question) => q._id === questionID);

    if (question) {
      return question;
    }
    return {};
  };
}
